import { render, staticRenderFns } from "./FluxDuplicate.vue?vue&type=template&id=3773166b&scoped=true&"
import script from "./FluxDuplicate.vue?vue&type=script&lang=js&"
export * from "./FluxDuplicate.vue?vue&type=script&lang=js&"
import style0 from "./FluxDuplicate.vue?vue&type=style&index=0&id=3773166b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3773166b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VIcon,VProgressLinear,VRow})
